/**
 * Fișier cu utilități pentru animații - STANDARDIZAT
 * Definește variante uniforme de animații pentru întreaga aplicație
 */

// Constante pentru timing-uri standardizate
const STANDARD_DURATION = 0.6;
const STANDARD_EASE = "easeOut";

// Animație de fade in simplu
export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { duration: STANDARD_DURATION, ease: STANDARD_EASE }
  }
};

// Animație de fade in de jos în sus
export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: STANDARD_DURATION, ease: STANDARD_EASE }
  }
};

// Animație de fade in de la stânga
export const fadeInLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: STANDARD_DURATION, ease: STANDARD_EASE }
  }
};

// Animație de fade in de la dreapta
export const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: { duration: STANDARD_DURATION, ease: STANDARD_EASE }
  }
};

// Container pentru animații decalate (staggered)
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

// Opțiuni standard pentru viewport
export const standardViewport = { once: false, amount: 0.05 };

// Opțiuni îmbunătățite pentru viewport - folosiți acestea pentru animații mai sensibile
export const enhancedViewport = { once: false, amount: 0.01, margin: "-100px 0px -100px 0px" };

// Delay-uri standard pentru animații secvențiale
export const delayTransition = (delay) => ({
  delay,
  duration: STANDARD_DURATION
});

// Helper pentru tranziții simple inline
export const simpleTransition = {
  duration: STANDARD_DURATION,
  ease: STANDARD_EASE
};

// Animații speciale pentru ContactForm
export const successMessage = {
  hidden: { opacity: 0, y: -30, scale: 0.9 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: { 
      duration: STANDARD_DURATION, 
      ease: STANDARD_EASE,
      delay: 0.1
    }
  }
};

export const errorMessage = {
  hidden: { opacity: 0, y: -30, scale: 0.9 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: { 
      duration: 0.5, 
      ease: STANDARD_EASE
    }
  }
};

export const formReappear = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: STANDARD_DURATION, 
      ease: STANDARD_EASE,
      delay: 0.2
    }
  }
};

export const formExit = {
  opacity: 0,
  y: -20,
  transition: { 
    duration: STANDARD_DURATION, 
    ease: STANDARD_EASE
  }
};

export const messageExit = {
  opacity: 0,
  y: -10,
  scale: 0.95,
  transition: { 
    duration: STANDARD_DURATION, 
    ease: STANDARD_EASE
  }
};
